import { useButton } from '../Button/useButton';
export const useHyperlink = (props) => {
    const { buttonProps: { form, formAction, name, role, value, ...hyperlinkProps }, } = useButton(props);
    return {
        hyperlinkProps: {
            ...hyperlinkProps,
            'data-thc-style-override': true,
        },
    };
};
